import PropTypes from 'prop-types';
import React from 'react';
import ActionButton from './ActionButton';
import {t} from 'i18next';
import {Steps} from 'primereact/steps';

export const StepperComponent = ({
    model,
    preChangeStep,
    readOnly,
    outsideClassName,
    stepClassName,
    betwwenStepsComponent,
    lastStepButton,
    component,
    activeStep,
    onChangeActiveStep,
}) => {
    const isLastStep = () => {
        return model.length === activeStep + 1;
    };
    const isFirstStep = () => {
        return 0 === activeStep;
    };

    return (
        <div className={outsideClassName}>
            <Steps model={model} activeIndex={activeStep} readOnly={readOnly} className={stepClassName} />
            {component()}
            <div className='row justify-content-between stepper-component'>
                <div className='col-2'>
                    {!isFirstStep() && (
                        <ActionButton
                            id={'prev-step'}
                            reverse
                            handleClick={(e) => {
                                if (preChangeStep) {
                                    preChangeStep(() => {
                                        onChangeActiveStep(activeStep - 1);
                                    });
                                    return;
                                }
                                onChangeActiveStep(activeStep - 1);
                            }}
                            label={t('global.prev')}
                        ></ActionButton>
                    )}
                </div>
                {betwwenStepsComponent && <div className='col-2'>{betwwenStepsComponent()}</div>}
                {isLastStep() && lastStepButton && <div className='col-2'>{lastStepButton()}</div>}
                {!isLastStep() && (
                    <div className='col-2'>
                        {
                            <ActionButton
                                id={'next-step'}
                                reverse
                                style={{float: 'right'}}
                                handleClick={(e) => {
                                    if (preChangeStep) {
                                        preChangeStep(() => {
                                            onChangeActiveStep(activeStep + 1);
                                        });
                                        return;
                                    }
                                    onChangeActiveStep(activeStep + 1);
                                }}
                                label={t('global.next')}
                            />
                        }
                    </div>
                )}
            </div>
        </div>
    );
};

StepperComponent.defaultProps = {
    model: [],
    validation: undefined,
    outsideClassName: '',
    stepClassName: '',
    readOnly: true,
    lastStepButton: undefined,
    betwwenStepsComponent: undefined,
    components: [],
};

StepperComponent.propTypes = {
    outsideClassName: PropTypes.string,
    stepClassName: PropTypes.string,
    readOnly: PropTypes.bool,
    validation: PropTypes.func,
    model: PropTypes.array.isRequired,
    components: PropTypes.array.isRequired,
    lastStepButton: PropTypes.object,
    betwwenStepsComponent: PropTypes.object,
};

export default StepperComponent;
